export enum TableBlock {
  Root = 'Table',
}

export enum TableModifier {
  StickyFirstColumn = 'stickyFirstColumn',
}
